/*
 *   File : delete.js
 *   Author URI : https://evoqins.com
 *   Description : UI element which asks for confirmation while removing funds.
 *   Integrations : null
 *   Version : v1.1
 */
/* import packages */
import { useEffect, useState } from "react";

/* import components */
import { GradientButton, OutlineButton } from "../Cta";
import { Icon } from "../Icon";
import { toast } from "react-toastify";

/* import styles */
import style from "../../Styles/Components/delete.module.scss";

/* import helper */
import { closeModal } from "../../Helper/helper-function";
import APIService from "../../Services/api-service";

const DeleteConfirmationModal = (props) => {
    const [apiLoader, setApiLoader] = useState(false);

    useEffect(() => {
        var my_modal = document.getElementById("delete");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.close();
        });
        //eslint-disable-next-line
    }, [props.close]);

    const _handleCancel = () => {
        props.close();
    }

    const _handleDelete = () => {
        closeModal('delete');
        props.confirmDelete();
    }


    // API - delete FAQ
    const _deleteFaq = () => {
        setApiLoader(true);
        const url = 'content/delete';
        const data = {
            "content_id": props.data.id,
        }

        APIService(true, url, data).then((response) => {
            if (response.status_code === 200) {
                toast.dismiss();
                if (props.banner === true) {
                    toast.dismiss();
                    toast.success(`Banner deleted successfully`, {
                        type: "success"
                    });
                } else {
                    toast.dismiss();
                    toast.success(`FAQ deleted successfully`, {
                        type: "success"
                    });
                }

                _handleDelete()
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error"
                });
            }
            setApiLoader(false);
        });
    }


    // API - delete Banner
    const _deleteBanner = () => {
        setApiLoader(true);
        const url = 'banner/delete';
        const data = {
            "banner_id": props.banner_id,
        }

        APIService(true, url, data).then((response) => {
            if (response.status_code === 200) {
                _handleDelete()
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error"
                });
            }
            setApiLoader(false);
        });
    }

    return (
        <div className={`modal fade ${style.e_delete}`}
            id="delete"
            tabIndex="-1"
            aria-labelledby="delete"
            aria-hidden="true"
            data-bs-backdrop="true" >
            <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                <div className={`modal-content bg-white text-center d-flex align-items-center padding-32px-all ${style.e_content} `}>
                    <div className="col-12 d-flex justify-content-between">

                        <Icon icon="close"
                            size={24}
                            className="cursor-pointer ms-auto e-modal-close-btn"
                            data-bs-dismiss="modal" />
                    </div>
                    <img draggable={false} src={require("../../Assets/Images/Modal/delete-icon.png")}
                        alt="Delete account"
                        width={72}
                        height={72}
                    />


                    <p className="color-eerie-black e-poppins-medium e-font-18 mt-4 mb-0">
                        {props.content}
                    </p>

                    <div className="d-flex gap-8px margin-34px-top margin-32px-bottom  w-100 px-5">
                        <OutlineButton label="No, cancel"
                            cancel="modal"
                            className="padding-12px-tb px-3 white-space-nowrap  e-font-16 e-poppins-regular "
                            handleClick={_handleCancel} />
                        <GradientButton label="Yes, delete"
                            className="padding-12px-tb e-font-16 w-100 "
                            // cancel="modal"
                            loading={apiLoader}
                            onPress={() => {
                                if (props.banner) {
                                    _deleteBanner();
                                } else {
                                    _deleteFaq();
                                }
                            }} />
                    </div>
                </div>
            </div>
        </div>
    )
}


DeleteConfirmationModal.defaultProps = {
    close: () => { },
    fund: {
        fund_name: ""
    }
}

export default DeleteConfirmationModal